import React from "react";
import styled from "styled-components";

interface PostFieldLabelProps {
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
}

const PostFieldLabelBase = ({
  children,
  className = "",
  disabled,
  ...other
}: PostFieldLabelProps) => {
  return (
    <div
      className={`font-inter text-sm font-medium leading-5 text-[#454545] ${disabled ? "opacity-50" : ""} ${className}`}
      {...other}
    >
      {children}
    </div>
  );
};

export const PostFieldLabel = styled(PostFieldLabelBase)``;

export default PostFieldLabel;
